
import { useNavigate } from "react-router-dom";
import { goToLink, RedemnessReady, RedemnessStatus } from '../projectData';
import { useEffect, useState } from 'react';
import { getUserDashboard } from '../api';

/**
 * RedemnessDashboard component displays user points and KYC status without login.
 * Handles dashboard data, document verification, and redemption actions.
 */
const KycWithoutLoginDashboard = () => {
    // const { user_ref } = useParams();
    const navigate = useNavigate();

    const [dashboard, setDashboard] = useState()
    const user_ref = "U-IIRPL-244846"
    useEffect(() => {
        getUserDashboard({ project_key: "TEST-PROJECT-PCLGTZNS-P1", id: user_ref }).then((d) => setDashboard(d.data))
    }, [])
    return (
        <>
            <div className="container bg-white user_points vh-100">
                <div className="row mt-6">
                    <div className="col-md-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">

                        <div className='text-center'>
                            <div className='fs-4 fw-semibold'>You Have</div>
                            <h1 className='display-2 text-danger'>{dashboard?.totalBalance ? dashboard?.totalBalance : '0'}</h1>
                            <div className='fs-4 '>Points</div>
                        </div>
                        <div className='d-flex justify-content-between my-4'>
                            <div className='card ' style={{ width: "45%", border: "1px solid #E6E6E6" }}>
                                <div className='card-body p-5 text-center fs-6 fw-semibold'>
                                    {dashboard?.debit ? dashboard?.debit : '0'}
                                </div>
                                <div className='card-footer p-3 fs-6 fw-semibold   text-center ' style={{ backgroundColor: '#FBF6F7', color: "#ED1C24", }}>
                                    Redeem Points
                                </div>
                            </div>
                            <div className='card ' style={{ width: "45%", border: "1px solid #E6E6E6" }}>
                                <div className='card-body p-5 text-center fs-6 fw-semibold'>
                                    {dashboard?.credit ? dashboard?.credit : '0'}
                                </div>
                                <div className='card-footer p-3 fs-6 fw-semibold  text-center ' style={{ backgroundColor: '#F8FAFC', color: "#102844", }}>
                                    Balance Points
                                </div>
                            </div>
                        </div>
                        <RedemnessReady status={dashboard?.redemReadness} />
                        <div className='fs-6 fw-semibold my-4 text-center'>
                            It is a long established fact that a reader will be distracted by the readable content of a page
                        </div>
                        <>
                            {dashboard ? (
                                <RedemnessStatus dashboard={dashboard} />
                            ) : (
                                <div className="text-center">
                                    <div className="spinner-border text-danger" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            )}
                        </>

                        <div className='d-flex flex-column gap-4 align-items-center my-4'>
                            <button className="btn bg-danger text-white w-75" onClick={() => goToLink(navigate, `/customer/bankpancard-details/${user_ref}`, dashboard?.kyc)}  >
                                Be Redemption Ready <i className="bi bi-chevron-right"></i>
                            </button>
                            <button className="btn bg-dark text-white w-75" onClick={() => goToLink(navigate, `/customer/redem-category`, dashboard)} >
                                I Shall Do It Later <i className="bi bi-chevron-right"></i>
                            </button>

                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default KycWithoutLoginDashboard